export default __webpack_public_path__ + "static/media/help.8b9af289.svg";